import React from "react";

var FeeBuilderErrors = {
  renderErrors: function (errors) {
    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>;
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  },

  renderGeneralErrors: function (errors) {
    return this.renderErrors(this.generalErrors(errors));
  },

  renderGuestTypeErrors: function(errors) {
    return this.renderErrors(this.guestTypeErrors(errors))
  },

  guestTypeErrors: function(errors) {
    var err = [];

    if (!errors) {
      return err;
    }

    if (errors.guest_types && errors.guest_types.length) {
      for (var i = 0, ilen = errors.guest_types.length; i < ilen; i++) {
        err.push(errors.guest_types[i]);
      }
    }
    return err;
  },

  generalErrors: function (errors) {
    var err = [];

    if (!errors) {
      return err;
    }

    if (errors.name && errors.name.length) {
      for (var i = 0, ilen = errors.name.length; i < ilen; i++) {
        err.push(I18n.t("name") + " " + errors.name[i]);
      }
    }

    if (errors.code && errors.code.length) {
      for (var i = 0, ilen = errors.code.length; i < ilen; i++) {
        err.push(I18n.t("code") + " " + errors.code[i]);
      }
    }

    if (errors.start_date && errors.start_date.length) {
      for (var i = 0, ilen = errors.start_date.length; i < ilen; i++) {
        err.push(I18n.t("begins") + " " + errors.start_date[i]);
      }
    }

    if (errors.percentage && errors.percentage.length) {
      for (var i = 0, ilen = errors.percentage.length; i < ilen; i++) {
        err.push(errors.percentage[i]);
      }
    }

    if (errors.amount && errors.amount.length && !errors.percentage) {
      for (var i = 0, ilen = errors.amount.length; i < ilen; i++) {
        err.push(I18n.t("amount") + " " + errors.amount[i]);
      }
    }

    if (errors.tax_fee_unit && errors.tax_fee_unit.length) {
      for (var i = 0, ilen = errors.tax_fee_unit.length; i < ilen; i++) {
        err.push(I18n.t("tax_fee_unit") + " " + errors.tax_fee_unit[i]);
      }
    }

    if (errors.tax_fee_type && errors.tax_fee_type.length) {
      for (var i = 0, ilen = errors.tax_fee_type.length; i < ilen; i++) {
        err.push(I18n.t("type") + " " + errors.tax_fee_type[i]);
      }
    }

    return err;
  },
};

export default FeeBuilderErrors;
